import { SxProps, Theme } from '@mui/material';

type TStyles = {
  iconButton: SxProps<Theme>;
};

export const styles: TStyles = {
  iconButton: {
    padding: 0,
    margin: 0,
    background: 'none',
    '&:hover': {
      background: 'none',
    },
  },
};
